import loadable from 'loadable-components';

export default loadable(() => import('./index'));
